<nav class="navigation-menu w-full">
  @for (item of items(); track item.label) {
    @if (item.items && item.items.length > 0) {
      <!-- Item with children - expandable -->
      <div class="nav-group">
        <button
          class="nav-item nav-item-expandable"
          type="button"
          [class.active]="isGroupActive(item)"
          (click)="toggleGroup(item)"
        >
          <i [class]="item.icon"></i>
          <span>{{ item.label }}</span>
          <i class="pi pi-chevron-down expand-icon" [class.expanded]="isGroupExpanded(item)"></i>
        </button>
        @if (isGroupExpanded(item)) {
          <div class="nav-submenu">
            @for (subItem of item.items; track subItem.label) {
              <a
                class="nav-subitem"
                [routerLink]="subItem.routerLink"
                routerLinkActive="active"
              >
                <i [class]="subItem.icon"></i>
                <span>{{ subItem.label }}</span>
              </a>
            }
          </div>
        }
      </div>
    } @else {
      <!-- Item without children - direct link -->
      <a
        class="nav-item"
        [routerLink]="item.routerLink"
        routerLinkActive="active"
      >
        <i [class]="item.icon"></i>
        <span>{{ item.label }}</span>
      </a>
    }
  }
</nav>
